import React from 'react';
import { Box } from '@mui/material';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import { requiredValidation, withFormEventValidation } from '../../validatableComponent';
import { State } from '../redux';

const EventTypeFormInput = withFormEventValidation(FormInput, requiredValidation);

type ComponentState = State['emConfiguration']['loyaltyEvent'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  fieldDisabled: (field: Fields) => boolean;
};
const LoyaltyEventConfiguration: React.FC<Props> = (props) => {
  const { eventType, fieldDisabled } = props;

  return (
    <Box>
      <Box my={4}>
        <EventTypeFormInput
          id='eventType'
          label='Event Type'
          readonly={fieldDisabled('eventType')}
          type='text'
          value={eventType}
          required={true}
        />
      </Box>
    </Box>
  );
};

export { LoyaltyEventConfiguration };
